import { IvformModule } from 'ivforms';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AuthService } from 'src/app/services/auth.service';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { DatePipe } from '@angular/common';

import { provideIonicAngular } from '@ionic/angular/standalone';

import { IonApp, IonicRouteStrategy, IonRouterOutlet, IonSplitPane, IonMenu, IonHeader, IonToolbar, IonTitle, IonContent, IonList, IonMenuToggle, IonItem, IonIcon, IonLabel } from '@ionic/angular/standalone';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';


import { PopoverModal } from './services/alert.service';
import { UtilsService } from './services/utils.service';
import { IframeHandlerComponent } from 'src/app/components/common/iframe-handler/iframe-handler.component';

//import { PopoverController } from '@ionic/angular';
//import { IonRouterOutlet } from '@ionic/angular/common';



@NgModule({
    declarations: [AppComponent],
    imports: [
        BrowserModule,
        IframeHandlerComponent,
        IvformModule,
        /**
         * Steve: I remember I commented above line `IonicModule.forRoot()` when adding the innerHTMLTemplatesEnabled
         * Unsure if we should uncomment it out.
         */
        // IonicModule.forRoot(),
        //    IonicModule.forRoot({ innerHTMLTemplatesEnabled: true }),
        AppRoutingModule,
        //FormsModule,
        //ReactiveFormsModule,
        IonApp,
        IonRouterOutlet,
        IonSplitPane,
        IonMenu,
        IonHeader,
        IonToolbar,
        IonTitle,
        IonContent,
        IonList,
        IonMenuToggle,
        IonItem,
        IonIcon,
        IonLabel
    ],
    providers: [
        AuthService,
        DatePipe,
        { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
        UtilsService,
        /**
         * Steve: I added this 'innerHTMLTemplatesEnabled: true' so we could handle HTML within 
         * this.alertService.alert error message, this to show several errors returned from the API.
         */
        provideIonicAngular({ innerHTMLTemplatesEnabled: true, hardwareBackButton: true })
    ],
    bootstrap: [AppComponent],
})
export class AppModule { }
